export const phoneRegex = /^(\s*)?(\+)?([- _():=+]?\d[- _():=+]?){10,14}(\s*)?$/;

export const phoneRegexRussian = /^\+7\d{10}$/;
